import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { Faq } from '../../types/content';
interface FaqListProps {
  items: Faq[];
}
export function FaqList({
  items
}: FaqListProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <ul className="mt-12" data-id="element-262" data-mp="2v6dlop1tenx2">
      {items.map((item, index) => {
      const isOpen = openIndex === index;
      return <li key={item.question} className="rule" data-id="element-263" data-mp="1yeti73vfu4g3" data-mpi={index}>
            <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-start justify-between gap-6 py-6 text-left" data-id="element-264" data-mp="22j9nb2x897u9">
              <span className="font-serif text-xl leading-snug text-ink md:text-2xl" data-id="element-265" data-mp="1esnfncr4xpks">
                {item.question}
              </span>
              {isOpen ? <MinusIcon className="mt-1 h-5 w-5 shrink-0 text-brick" strokeWidth={1.5} data-id="element-266" data-mp="1jq5o7218q2s9" /> : <PlusIcon className="mt-1 h-5 w-5 shrink-0 text-ink-muted" strokeWidth={1.5} data-id="element-267" data-mp="25k9h3sgnwlea" />}
            </button>
            <AnimatePresence initial={false} data-id="element-268" data-mp="1wplc83f015q0">
              {isOpen && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.22,
            ease: [0.23, 1, 0.32, 1]
          }} className="overflow-hidden" data-id="element-269" data-mp="1wnqt8unafnok">
                  <p className="max-w-2xl pb-7 text-base leading-relaxed text-ink-soft" data-id="element-270" data-mp="1dqh4qz33vk0g">
                    {item.answer}
                  </p>
                </motion.div>}
            </AnimatePresence>
          </li>;
    })}
    </ul>;
}